import React, { useEffect, useState, useCallback } from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './components/LoginPage/LoginPage';
import QueryEditorPage from './components/QueryEditorPage/QueryEditorPage';
import PipelinesPage from './components/PipelinesPage/PipelinesPage';
import SideNavBar from './components/SideNavBar/SideNavBar';
import AboutMaple from './components/AboutMaple/AboutMaple';
import FeedbackTablePage from "./util/FeedbackTablePage/FeedbackTablePage";
import { saveUserSession, startTokenExpirationCheck } from "./api";
import { setSessionExpiredCallback } from "./api";
import SessionExpiredModal from './components/SessionExpiredModal/SessionExpiredModal';
import AuthLoadingScreen from "./util/AuthLoadingScreen/AuthLoadingScreen";

const App = () => {
  const [showSessionExpiredModal, setShowSessionExpiredModal] = useState(false);
  const [hasTabsWithQueries, setHasTabsWithQueries] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);

  const handleSessionExpired = useCallback(() => {
    setShowSessionExpiredModal(true);
  }, []);

  useEffect(() => {
    setSessionExpiredCallback(handleSessionExpired);
    if (window.location.pathname !== "/login") {
      startTokenExpirationCheck();
    }
  }, [handleSessionExpired]);

  const HealthCheck = () => {
    return (
      <div>
        {JSON.stringify({
          status: "UP",
          timestamp: new Date().toISOString(),
        })}
      </div>
    );
  };

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" exact Component={LoginPage} />
          <Route path="/*" element={<ProtectedRoutes setHasTabsWithQueries={setHasTabsWithQueries} hasTabsWithQueries={hasTabsWithQueries} 
          setSessionExpired={setSessionExpired} sessionExpired={sessionExpired} />} />
          <Route path="/health" element={<HealthCheck />} />
          <Route path="/auth" element={<AuthLoadingScreen />} />
        </Routes>
      </Router>
      <SessionExpiredModal
        open={showSessionExpiredModal}
        onHide={() => setShowSessionExpiredModal(false)}
        hasTabsWithQueries={hasTabsWithQueries}
        setSessionExpired={setSessionExpired}
        sessionExpired={sessionExpired}
      />
    </>
  );
};

const ProtectedRoutes = ({ setHasTabsWithQueries, hasTabsWithQueries, setSessionExpired, sessionExpired }) => {
  const path = window.location.pathname;
  const showSideNavBar = path !== '/';
  const [user, setUser] = useState(JSON.parse(sessionStorage.getItem('user')));

  useEffect(() => {
    if (user == null) {
      saveUserSession();
      const savedUser = JSON.parse(sessionStorage.getItem('user'));
      setUser(savedUser);
    }
  }, [user]);

  const isAuthorized = user && user.admin;
  return (
    <>
      {showSideNavBar && <SideNavBar isAuthorized={isAuthorized} hasTabsWithQueries={hasTabsWithQueries} sessionExpired={sessionExpired} appearance="inverse" />}
      <Routes>
        <Route path="/query-editor" element={<QueryEditorPage setHasTabsWithQueries={setHasTabsWithQueries} />} />
        <Route path="/pipelines" element={<PipelinesPage />} />
        <Route path="/feedback-table" element={<FeedbackTablePage />} />
        <Route path="/about" element={<AboutMaple />} />
      </Routes>
    </>
  );
};

export default App;